import $ from 'jquery';
import bootstrap from './vendor/bootstrap';
import { homeInit } from './apa.home';
import { seeInit } from './apa.see';
import { beInit } from './apa.be';
import { amInit } from './apa.am';

window.$ = $;
let _last_scroll_position = 0;
let _menu_open = false;
let padding = 40;


$(document).ready(function() {
	
	if ($('#home').length > 0) {
		homeInit();
	} else if ($('#see').length > 0) {
		seeInit();
	} else if ($('#be').length > 0) {
		beInit();
	} else if ($('#am').length > 0) {
		amInit();
	}
	
	$('menu').hide();
	
	$(window).resize(function() {		
		if (_menu_open) {
			centerMenu();
		}
	});
	
	$(window).on('scroll', function(e) {
		let scroll_top = $(this).scrollTop();

		if (scroll_top > 0 && _last_scroll_position == 0) {
			$('nav').addClass('sticky');
		} else if (scroll_top == 0 && _last_scroll_position > 0) {
			$('nav').removeClass('sticky');
		}
		
		_last_scroll_position = scroll_top;
	});
	
	$('.hamburger').click(function() {
		$('nav').addClass('fade');
		$('menu').show();
		setTimeout(function() {
			_menu_open = true;
			$('body').addClass('locked');
			centerMenu();
			
			$('menu').removeClass('fade');
			$('.menu-content').removeClass('fade');
			
			setTimeout(function() {
				$('menu').addClass('scrollable');
			}, 500);
		}, 1);		
	});
	
	$('.close-button').click(function() {
		$('nav').removeClass('fade');
		$('menu').removeClass('scrollable');
		$('menu').addClass('fade');
		$('.menu-content').addClass('fade');
		setTimeout(function() {
			$('menu').hide();
			_menu_open = false;
			$('body').removeClass('locked');
		}, 500);
	});
	
	$('a[href*=#]:not([href=#])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		if (target.length) {
			var scroll_to = target.offset().top - $('nav').height();
			var distance = $(window).scrollTop() - scroll_to;
			if (distance < 0) {
				distance = distance * -1;
			}
			var speed = distance * .3;
			
			$('html,body').animate({
				scrollTop: scroll_to
			}, speed);
			return false;
		}
    }
  });
	
});

function centerMenu() {
	var padding = 40;
	var menu_height = $('.menu-content').height();
	var top_height = $('.menu-top').height() + $('.menu-top').position().top + padding;
	var available_height = $(window).height() - top_height;
	
	
	if ((available_height - padding) > menu_height) {
		$('.menu-content').css('margin-top', (available_height - menu_height) / 2);	
	}
}